import type { MetaAdsTranslations } from '../interfaces/metaAds';

export const metaAdsTranslations: MetaAdsTranslations = {
  page_title: 'Meta Ads',
  page_subtitle:
    'Conecte sua conta de anúncios da Meta e acompanhe o desempenho das suas campanhas.',
  manage_connection: 'Gerenciar conexão',

  connect_title: 'Conectar Meta Ads',
  connect_body:
    'Faça login com o Facebook para vincular uma conta de anúncios e ver aqui os dados das suas campanhas.',
  connect_button: 'Conectar com o Facebook',
  sdk_error:
    'Não foi possível carregar o SDK do Facebook. Desative seu bloqueador de anúncios nesta página e recarregue.',
  config_missing:
    'O login do Meta Ads ainda não está configurado para este ambiente.',
  toast_connected: 'Conta do Facebook conectada',
  toast_cancelled: 'Login cancelado',
  toast_error: 'Algo deu errado. Tente novamente.',

  pick_account_title: 'Escolha uma conta de anúncios',
  pick_account_body:
    'Seu login do Facebook está conectado. Escolha a conta de anúncios que deseja acompanhar.',
  reload_accounts: 'Recarregar contas',
  available_empty:
    'Nenhuma conta de anúncios visível com este login do Facebook.',
  account_connect: 'Conectar',
  account_connected: 'Conectada',
  account_not_covered: 'Sem acesso',
  toast_account_connected: 'Conta de anúncios conectada',

  account_select_label: 'Conta de anúncios',
  range_label: 'Período',
  range_today: 'Hoje',
  range_7d: 'Últimos 7 dias',
  range_14d: 'Últimos 14 dias',
  range_30d: 'Últimos 30 dias',
  sync_button: 'Sincronizar agora',
  toast_sync_started:
    'Sincronização iniciada — os dados serão atualizados em instantes',
  refresh_button: 'Atualizar',

  summary_spend: 'Investimento',
  summary_impressions: 'Impressões',
  summary_clicks: 'Cliques',
  summary_ctr: 'CTR',
  summary_cpc: 'CPC',
  summary_conversations: 'Conversas',
  settling_note:
    'Parte dos dados recentes ainda está sendo consolidada na Meta e pode mudar levemente.',

  campaigns_title: 'Campanhas',
  campaigns_empty_title: 'Ainda não há dados de campanhas',
  campaigns_empty_body:
    'Execute uma sincronização para trazer as campanhas e métricas da Meta para o período selecionado.',
  table_campaign: 'Campanha',
  table_status: 'Status',
  table_spend: 'Investimento',
  table_impressions: 'Impressões',
  table_clicks: 'Cliques',
  table_conversations: 'Conversas',
  table_cost_per_conversation: 'Custo / conv.',
  status_active: 'Ativa',
  status_paused: 'Pausada',
};
